document.addEventListener("DOMContentLoaded", function () {
  
  // Check if MutationObserver is supported
  if (typeof MutationObserver === 'undefined') {
    console.warn('MutationObserver is not supported in this browser');
    return;
  }

  // Check if document.body exists
  if (!document.body) {
    console.warn('document.body is not available');
    return;
  }

  // Fix "Deliver every" wording
  const observer = new MutationObserver(() => {
    try {
      document.querySelectorAll("label").forEach(el => {
        if (el.textContent && el.textContent.includes("Deliver every")) {
          el.innerHTML = el.innerHTML.replace("Deliver every", "Renew every");
          console.debug(el)
        }
      });
    } catch (error) {
      console.error('Error in mutation observer callback:', error);
    }
  });

  try {
    observer.observe(document.body, { 
      childList: true, 
      subtree: true,
      characterData: true,
      characterDataOldValue: true
    });
  } catch (error) {
    console.error('Error setting up mutation observer:', error);
  }
  
});